import { Controller } from '@hotwired/stimulus'
import './accordion_component.scss'

export default class extends Controller {
  static values = {
    allowMultiple: Boolean,
    iconStyle: String,
  }

  itemOpened(event) {
    if (this.allowMultipleValue) return

    // Close all other accordion items
    const openedItem = event.target.closest(
      '[data-controller*="builder--accordion-item"]'
    )
    this.element
      .querySelectorAll(
        ':scope > .node-content > [data-controller*="builder--accordion-item"]'
      )
      .forEach((item) => {
        if (item !== openedItem) {
          item.dispatchEvent(
            new CustomEvent('accordion:close', { bubbles: false })
          )
        }
      })
  }
}
